// TODO: REFACTORING
import React from 'react';
import * as Styled from './CreditCardInput.styles';

const CreditCardInput = ({ customStyle, children, forwardRef }) => (
  <Styled.Label customStyle={customStyle} ref={forwardRef}>
    {children}
  </Styled.Label>
);

export default CreditCardInput;
